
// 網路相關設定
const imgAddress = process.env.VUE_APP_IMAGES_FROM_APACHE_DOMAIN
const imgDomain = process.env.VUE_APP_IMAGES_FROM_CLIENT_DOMAIN

// ie 10 不支援 window.location.origin
const baseaddress = !window.location.origin
  ? window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
  : window.location.origin

const network = Object.freeze({
  // api 網址
  baseAddress: baseaddress + '/etag/api/',
  // apache 圖檔資源路徑
  imgAddress,
  // 連線逾時秒數
  timeout: 600,
  // otp 逾時秒數
  otpTimeout: 600,
  // ctbc 圖檔資源路徑
  imgDomain
})

export default network
